import React, { FC } from 'react';
import { useDroppable } from '@dnd-kit/core';
import styles from './WorkoutBuilderModal.module.scss';

export interface DroppableSupersetGroupProps {
  groupId: string;
  supersetGroup: string;
  isOver: boolean;
  children: React.ReactNode;
}

const DroppableSupersetGroup: FC<DroppableSupersetGroupProps> = ({ groupId, isOver, children }) => {
  const { setNodeRef } = useDroppable({ id: `drop-superset-${groupId}` });
  return (
    <div
      ref={setNodeRef}
      className={`${styles.supersetDropZone}${isOver ? ` ${styles.supersetDropZoneActive}` : ''}`}
    >
      {children}
    </div>
  );
};

export default DroppableSupersetGroup;
